<canvas *ngIf="thematics" baseChart
        class="chart"
        [width]="width"
        [height]="height"
        [data]="chartData"
        [type]="type"
        [options]="chartOptions"
></canvas>
